/* global module*/

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withT } from '../../../lib/wrappers';

class MissingComponent extends Component {

  constructor(props, context) {
    super(props, context);
    const missing = this;
    missing.state = {};
  }

  get t() {
    return this.props.t;
  }

  render() {
    return (
      <div className="alert alert-danger missing">{this.t('This route does not exist.')}</div>
    );
  }

}

MissingComponent.propTypes = {
  t: PropTypes.func.isRequired,
};
MissingComponent.NAME = 'Missing';

export default withT()(MissingComponent);
